import React, { useRef } from "react";

import { Modal } from "antd";
import { useMediaQuery } from "react-responsive";
import { DESKTOP_WIDTH } from "@bundles/consts";
import YouTube, { Options } from "react-youtube";

const playerSettings: Options = {
  height: "100%",
  width: "100%",
  playerVars: {
    rel: 0,
    showinfo: 0,
  },
};

type VideoPlayerModalProps = {
  open: boolean;
  videoId: string;
  onClose?: () => void;
};

export const VideoPlayerModal = ({
  open,
  videoId,
  onClose,
}: VideoPlayerModalProps) => {
  const isMobile = useMediaQuery({ maxWidth: DESKTOP_WIDTH });
  const playerRef = useRef();

  const playerEnd = (e) => {
    e.target.clearVideo();
  };

  return (
    <Modal
      className="tailwind-video-modal"
      footer={null}
      centered
      width={isMobile ? "100%" : "70%"}
      open={open}
      destroyOnClose
      onCancel={onClose}
    >
      <YouTube
        videoId={videoId}
        opts={playerSettings}
        onEnd={playerEnd}
        ref={playerRef}
        className="max-h-[520px] h-[100vh]"
      />
    </Modal>
  );
};
